"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const common_styled_components_1 = require("../../common-styled-components");
const react_1 = require("react");
const Modal_1 = require("../common/Modal");
const apiUtils_1 = require("../../../util/apiUtils");
const useEdit_1 = __importDefault(require("../../../hooks/useEdit"));
const routes_1 = require("../../../util/routes");
const NavigationContext_1 = require("../../../contexts/NavigationContext");
const tableColumns = [
    {
        key: "name",
        label: "Name",
    },
    {
        key: "legal_name",
        label: "Full legal name",
    },
    // {
    //   key: "ownedShipImoNumbers",
    //   label: "Owned ships",
    // },
    // {
    //   key: "operatedShipImoNumbers",
    //   label: "Operated ships",
    // },
    {
        key: "tools",
        label: "Tools",
    },
];
const CellContent = ({ company, contentKey, editCompany, removeCompany, }) => {
    switch (contentKey) {
        case "name":
            const link = `${routes_1.routeNames.admin}/${routes_1.routeNames.companyAdmin}/${company.id}`;
            return (0, jsx_runtime_1.jsx)(NavigationContext_1.LinkWithHistory, { to: link, children: company.name });
        case "tools":
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => removeCompany(company), children: "Remove" }), (0, jsx_runtime_1.jsx)(common_styled_components_1.SmallButton, { onClick: () => editCompany(company), children: "Edit" })] }));
        case "years":
            return (0, jsx_runtime_1.jsx)("div", {});
        default:
            return (0, jsx_runtime_1.jsx)("div", { children: company[contentKey] });
    }
};
exports.default = () => {
    const [companies, _setUrl, _setBody, refresh] = (0, useFetch_1.default)("admin/companies.json", undefined);
    const [editStatus, executeEdit] = (0, useEdit_1.default)("admin/company.json", refresh);
    const [modal, setModal] = (0, react_1.useState)({});
    const addCompany = () => {
        setModal({
            type: "add",
            value: undefined,
        });
    };
    const editCompany = (company) => {
        setModal({
            type: "edit",
            value: company,
        });
    };
    const removeCompany = (company) => {
        setModal({
            type: "remove",
            value: company,
        });
    };
    const submit = (type, value) => {
        setModal({});
        if (type === "add") {
            if (value.name && value.name !== "") {
                const data = {
                    name: value.name,
                    legal_name: value.legal_name,
                    username: value?.username,
                    id: null,
                };
                executeEdit(data, "PUT");
            }
            else {
                alert("Empty name");
            }
        }
        if (type === "edit") {
            if (value.name && value.name !== "") {
                const data = {
                    name: value.name,
                    legal_name: value.legal_name,
                    username: value?.username,
                    id: value.id ?? null,
                };
                executeEdit(data, "PUT");
            }
            else {
                alert("Empty name");
            }
        }
        if (type === "remove") {
            if (value.id !== undefined) {
                const data = {
                    id: value.id,
                };
                executeEdit(data, "DELETE");
            }
            else {
                alert("Empty name");
            }
        }
    };
    return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [modal.type && ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { type: "company", isOpen: modal.type !== undefined, closeModal: () => setModal({}), modalType: modal.type, value: modal.value, submit: submit })), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.TitleWithExtraContent, { titleLevel: "Section", extraContent: (0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { onClick: addCompany, children: "+ Add" }), children: "Companies" }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Table, { children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { children: [tableColumns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TH, { children: c.label }, c.key))), " "] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: companies.status === apiUtils_1.LoaderStatus.Success &&
                                        companies.data.map((company) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TR, { children: tableColumns.map((c) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.TD, { children: (0, jsx_runtime_1.jsx)(CellContent, { contentKey: c.key, company: company, removeCompany: removeCompany, editCompany: editCompany }) }, c.key))) }, company.id))) })] })] }) })] }));
};
